/* Kiddora Nepal — privacy-safe personalization (Task 5)
 * First-party only. Uses the visitor's own browser (localStorage) — no cookies,
 * no third-party calls, no personal data. Product data is fetched from the store's
 * own first-party JSON endpoints. Degrades gracefully with JS disabled (the server
 * renders nothing personalized; containers stay hidden).
 */
(function () {
  var cfg = document.getElementById('kd-pers-config');
  if (!cfg || cfg.getAttribute('data-enable') === 'false') return;

  var tmpl = cfg.getAttribute('data-template');
  var K_AGE = 'kiddora_age_v1', K_RECENT = 'kiddora_recent_v1', K_SEEN = 'kiddora_seen_v1';
  var AGE_HANDLES = ['0-1yrs', '1-2-years', '2-4-years', '4-plus-years'];

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function https(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function money(v) {
    var n = typeof v === 'string' ? parseFloat(v) : (v || 0) / 100; // .js = cents, products.json = major-unit string
    if (isNaN(n)) return '';
    return 'Rs ' + Math.round(n).toLocaleString('en-IN');
  }

  /* --- capture: age selection (any click on a Shop-by-Age collection link) --- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/collections/"]') : null;
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/collections\/([a-z0-9\-]+)/i);
    if (m && AGE_HANDLES.indexOf(m[1]) > -1) lsSet(K_AGE, m[1]);
  }, true);

  /* --- capture: recently viewed products (product pages) --- */
  if (tmpl === 'product') {
    var h = cfg.getAttribute('data-product-handle');
    if (h) {
      var rec = lsGet(K_RECENT) || [];
      rec = rec.filter(function (x) { return x !== h; });
      rec.unshift(h);
      lsSet(K_RECENT, rec.slice(0, 12));
    }
  }

  var returning = !!lsGet(K_SEEN);
  lsSet(K_SEEN, true);

  if (tmpl !== 'index') return; // only the homepage renders personalized UI

  /* --- 5.3 dynamic hero message (new vs returning vs festive season) --- */
  var msgEl = document.querySelector('.kd-pers__msg');
  if (msgEl) {
    var month = (new Date()).getMonth(); // 0-11
    var festive = (month === 8 || month === 9 || month === 10); // Sep–Nov (Dashain/Tihar window)
    var msg = cfg.getAttribute('data-msg-new');
    if (festive && cfg.getAttribute('data-msg-festive')) msg = cfg.getAttribute('data-msg-festive');
    else if (returning && cfg.getAttribute('data-msg-returning')) msg = cfg.getAttribute('data-msg-returning');
    if (msg) { msgEl.textContent = msg; msgEl.hidden = false; }
  }

  function card(p) {
    // Built with DOM methods only (no innerHTML) — no XSS surface even for store data.
    var a = el('a', 'kd-pers__card');
    a.setAttribute('href', '/products/' + encodeURIComponent(p.handle));
    var imgWrap = el('span', 'kd-pers__img');
    var img = https(p.image);
    if (img) {
      var im = el('img');
      im.loading = 'lazy'; im.width = 300; im.height = 300;
      im.src = img; im.alt = p.title || '';
      imgWrap.appendChild(im);
    }
    a.appendChild(imgWrap);
    a.appendChild(el('span', 'kd-pers__ct', p.title || ''));
    if (p.price != null && p.price !== '') a.appendChild(el('span', 'kd-pers__pr', money(p.price)));
    return a;
  }
  function renderRow(sel, heading, items) {
    var sec = document.querySelector(sel);
    if (!sec || !items || !items.length) return;
    sec.querySelector('.kd-pers__heading').textContent = heading;
    var grid = sec.querySelector('.kd-pers__grid');
    grid.textContent = '';
    items.forEach(function (p) { grid.appendChild(card(p)); });
    sec.hidden = false;
  }

  /* --- 5.1 "Picked for your little one" — remembered age collection --- */
  var age = lsGet(K_AGE);
  if (age && AGE_HANDLES.indexOf(age) > -1) {
    fetch('/collections/' + age + '/products.json?limit=6', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products) return;
        var items = d.products.slice(0, 6).map(function (p) {
          return {
            handle: p.handle, title: p.title,
            image: (p.images && p.images[0] && p.images[0].src) || '',
            price: (p.variants && p.variants[0] && p.variants[0].price) || null
          };
        });
        renderRow('.kd-pers__age', cfg.getAttribute('data-age-heading') || 'Picked for your little one', items);
      })
      .catch(function () {});
  }

  /* --- 5.2 "Recommended for you" — recently viewed products --- */
  var recent = (lsGet(K_RECENT) || []).slice(0, 8);
  if (recent.length) {
    Promise.all(recent.map(function (hh) {
      return fetch('/products/' + hh + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var items = list.filter(Boolean).map(function (p) {
        return { handle: p.handle, title: p.title, image: p.featured_image || (p.images && p.images[0]) || '', price: p.price };
      });
      renderRow('.kd-pers__reco', cfg.getAttribute('data-reco-heading') || 'Recommended for you', items);
    }).catch(function () {});
  }

  /* --- 5.4 quiz finder (progressive enhancement over real collection links) --- */
  var finder = document.querySelector('.kd-finder');
  if (finder) {
    var ageStep = finder.querySelector('[data-step="age"]');
    var interestStep = finder.querySelector('[data-step="interest"]');
    var results = finder.querySelector('.kd-finder__results');
    var chosenAgeLabel = '';
    finder.addEventListener('click', function (e) {
      var opt = e.target.closest('.kd-finder__opt');
      if (!opt) return;
      if (opt.hasAttribute('data-age')) {
        e.preventDefault();
        lsSet(K_AGE, opt.getAttribute('data-age')); // also feeds "Picked for your little one"
        chosenAgeLabel = opt.textContent.trim();
        ageStep.hidden = true; interestStep.hidden = false; results.hidden = true;
      } else if (opt.hasAttribute('data-col')) {
        e.preventDefault();
        var col = opt.getAttribute('data-col');
        var label = opt.textContent.trim();
        fetch('/collections/' + col + '/products.json?limit=24', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.products) return;
            var grid = results.querySelector('.kd-finder__grid');
            grid.textContent = '';
            d.products.slice(0, 24).forEach(function (p) {
              grid.appendChild(card({ handle: p.handle, title: p.title, image: (p.images && p.images[0] && p.images[0].src) || '', price: (p.variants && p.variants[0] && p.variants[0].price) || null }));
            });
            results.querySelector('.kd-finder__resulttitle').textContent = label + (chosenAgeLabel ? (' • ages ' + chosenAgeLabel) : '');
            results.querySelector('.kd-finder__seeall').setAttribute('href', '/collections/' + col);
            interestStep.hidden = true; results.hidden = false;
          })
          .catch(function () {});
      }
    });
  }
})();
